<template>
  <div class="notfound">
    <div class="notfound-icon">
      <img src="./images/404.png" alt="404" />
    </div>
    <div class="notfound-title">没有找到你想要的页面…</div>
    <div class="notfound-button__group">
      <router-link replace to="/">
        <el-button size="medium" type="danger">返回首页</el-button>
      </router-link>
      <a :href="`/concat` | hostBuild('corp')">
        <el-button size="medium">联系我们</el-button>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
};
</script>
<style lang="less" scoped>
.notfound {
  text-align: center;
}
.notfound-icon {
  margin-top: 15vh;
}
.notfound-title {
  font-size: 20px;
  line-height: 28px;
  color: var(--primary-color);
  margin-top: 36px;
  margin-bottom: 32px;
}
.notfound-button__group {
  a + a {
    margin-left: 30px;
  }
}
</style>
